/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GuestInvoiceData
 */
export interface GuestInvoiceData {
    /**
     * 
     * @type {string}
     * @memberof GuestInvoiceData
     */
    customerRegistryId?: string;
    /**
     * 
     * @type {string}
     * @memberof GuestInvoiceData
     */
    customerName?: string;
    /**
     * 
     * @type {string}
     * @memberof GuestInvoiceData
     */
    referencePerson?: string;
    /**
     * 
     * @type {string}
     * @memberof GuestInvoiceData
     */
    comment?: string;
}

/**
 * Check if a given object implements the GuestInvoiceData interface.
 */
export function instanceOfGuestInvoiceData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GuestInvoiceDataFromJSON(json: any): GuestInvoiceData {
    return GuestInvoiceDataFromJSONTyped(json, false);
}

export function GuestInvoiceDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GuestInvoiceData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'customerRegistryId': !exists(json, 'customerRegistryId') ? undefined : json['customerRegistryId'],
        'customerName': !exists(json, 'customerName') ? undefined : json['customerName'],
        'referencePerson': !exists(json, 'referencePerson') ? undefined : json['referencePerson'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
    };
}

export function GuestInvoiceDataToJSON(value?: GuestInvoiceData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'customerRegistryId': value.customerRegistryId,
        'customerName': value.customerName,
        'referencePerson': value.referencePerson,
        'comment': value.comment,
    };
}

